var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconcontactsphonemain = function SvgIconcontactsphonemain(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/contacts/icon.contacts.phone.main") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/contacts/icon.contacts.phone.main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70710678,2.70710678 L9.79289322,5.79289322 C10.1834175,6.18341751 10.1834175,6.81658249 9.79289322,7.20710678 L8.41421356,8.58578644 C7.63316498,9.36683502 7.63316498,10.633165 8.41421356,11.4142136 L13.5857864,16.5857864 C14.366835,17.366835 15.633165,17.366835 16.4142136,16.5857864 L17.7928932,15.2071068 C18.1834175,14.8165825 18.8165825,14.8165825 19.2071068,15.2071068 L22.2928932,18.2928932 C22.6834175,18.6834175 22.6834175,19.3165825 22.2928932,19.7071068 C22.0285955,19.9714045 21.7642977,20.2357023 21.5,20.5 C20.5,21.5 13.5,22.5 8,17 C2.5,11.5 3,5 4.5,3.5 C4.76429774,3.23570226 5.02859548,2.97140452 5.29289322,2.70710678 C5.68341751,2.31658249 6.31658249,2.31658249 6.70710678,2.70710678 Z",
    id: "Path-7",
    stroke: "#09BE86",
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconcontactsphonemain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.contacts.phone.main.e054212606719de6879b2e4e959dd379.svg";